import { api } from './client'

/** Trạng thái máy do SmartLab báo về. */
export type SmartLabStatus = 'offline' | 'stopped' | 'running' | 'error'

/** DTO thô từ BE proxy (GET /tea-machines) — giữ nguyên đơn vị PLC (phút). */
export interface TeaMachineDTO {
    machine_code: string
    status: SmartLabStatus
    running_time: number
    configured_time: number
    created_at: string
    updated_at: string
}

/** Payload điều khiển. machine_code bắt buộc; cần ít nhất status hoặc configured_time. */
export interface ControlTeaMachineRequest {
    machine_code: string
    status?: 'running' | 'stopped'
    configured_time?: number
}

export const teaMachineApi = {
    /**
     * Lấy trạng thái 36 máy. `fresh` = bỏ cache snapshot ở server, gọi thẳng
     * SmartLab (dùng cho màn điều khiển); bỏ trống = dùng cache 4s (máy trạm).
     */
    list: (opts?: { fresh?: boolean }) =>
        api.get<TeaMachineDTO[]>(
            '/tea-machines',
            opts?.fresh ? { params: { fresh: '1' } } : undefined,
        ),
    control: (data: ControlTeaMachineRequest) =>
        api.post<{ accepted: boolean }>('/tea-machines/control', data),
}
